<template>
    <ShadowBoxContainer>
        <ListContainer 
            :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
            imageLabel="General Information" 
            :heading="'What brand is your ' + category +'?'"
            :step="2"

        >
            <!-- brands -->
            <WhiteCategory v-for="(brand, index) in brands" :key="index" :categoryName="brand" :hasChild="false" @select="selectIndex(index)" :isSelected="selectedIndex === index" />
            
            <!-- other brand -->
            <div class="ph3 ph4-ns bt b--light-gray pointer"  @click="selectOther" :class="{'bg-light-gray' : otherSelected, 'hover-bg-near-white' : !otherSelected}">
                <div class="flex items-center">
                    <div class="pv4">Other</div>
                    <Textbox v-model="otherBrand" id="myDiv" ref="myDiv" placeholder="Brand Name..." class="ml3 w-50-ns" v-if="otherSelected" :focused="true" />
                </div>
            </div>

        </ListContainer>

        <!-- navigation buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Back" forward="Next" :enabledForward="brandSpecified" @backClick="$router.push('/category')" @forwardClick="next" />
        </template>
    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import WhiteCategory from '@/components/list/shared/WhiteCategory.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import Textbox from '@/components/controls/Textbox.vue';
import { mapMutations } from 'vuex';

export default {
    components: {
        ShadowBoxContainer,
        WhiteCategory,
        NavigationButtons,
        ListContainer,
        Textbox
    },
    data() {
        return {
            category: 'Skill Saw',
            brands: ['Dewalt', 'Makita', 'Bosch', 'Milwakee', 'MasterCraft'],
            selectedIndex: null,
            otherBrand: null
        };
    },
    computed: {
        otherSelected() {
            return this.otherBrand !== null;
        },
        brandSpecified() {
            return (
                this.selectedIndex !== null ||
                (this.otherBrand !== null && this.otherBrand.length > 0)
            );
        }
    },
    methods: {
        ...mapMutations('newListing', ['setBrand']),
        selectIndex(index) {
            this.selectedIndex = index;
            this.otherBrand = null;
        },
        selectOther() {
            this.selectedIndex = null;
            this.otherBrand = '';
        },
        next() {
            if (this.otherSelected) {
                this.setBrand(this.otherBrand);
            } else {
                this.setBrand(this.brands[this.selectedIndex]);
            }
            this.$router.push('/add-photos');
        }
    }
};
</script>
